export const shouldLoad = () => document.querySelector('[data-controller~="table-multi-select-action"]') !== undefined;